<template>
    <div style="width: 350px; margin: auto">

        <div size="small" :inline="true">
            <div style="display: flex; align-items: center">
                <el-upload class="avatar-uploader" action="/api/v1/common/upload" accept=".jpg,.jpeg,.JPG,.JPEG,.png,.PNG" :show-file-list="false" :on-success="handleAvatarSuccess">
                    <el-image style="height: 60px; width: 60px; float: left" fit="scale-down" :src="formData.img" :lazy="true">
                        <div slot="error" class="image-slot">
                            <i class="el-icon-picture-outline" style="font-size: 40px"></i>
                        </div>
                    </el-image>
                    <el-button style="margin-left: 20px" class="el-button--small el-button--primary">upload logo</el-button>
                </el-upload>
            </div>
        </div>

        <el-form size="small" align="center" label-position="left" status-icon :model="formData" :rules="rules" ref="formData" label-width="105px">
            <el-form-item prop="img" hidden align="left">
                <el-input hidden v-model="formData.img"></el-input>
            </el-form-item>
            <el-form-item prop="prefix_no" align="left" label="Prefix">
                <el-col><el-input class="el-input--small" maxlength="2" v-model="formData.prefix_no" style="width:80px;"></el-input></el-col>
            </el-form-item>
            <el-form-item align="left" prop="icrafite_type" label="ICraftie Type">
                <el-select style="width: 150px" size="small" v-model="formData.icrafite_type" default-first-option placeholder="please select!">
                    <el-option v-for="item in types" :key="item.id" :label="item.label" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="icraftie_name" align="left" label="Name">
                <el-col><el-input class="el-input--small" maxlength="32" v-model="formData.icraftie_name"></el-input></el-col>
            </el-form-item>
            <el-form-item prop="describe" align="left" label="Describe">
                <el-col><el-input class="el-input--small" type="textarea" v-model="formData.describe"></el-input></el-col>
            </el-form-item>
            <el-form-item align="left" prop="record_time" label="Record Time">
                <el-select style="width: 150px" size="small" v-model="formData.record_time" default-first-option placeholder="please select!">
                    <el-option v-for="item in record_times" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item align="left" label="QC Test Audio">
                <el-row>
                    <el-col :span="12">
                        <el-upload class="avatar-uploader" action="/api/v1/common/upload" accept=".mp3,.MP3" :limit="1" :on-success="handleAudioSuccess">
                            <el-button style="margin-left: 20px" class="el-button--small el-button--primary">upload audio</el-button>
                        </el-upload>
                    </el-col>
                    <el-col v-if="formData.audio_url != ''" :span="10" style="margin-left: 15px">
                        <audio :src="formData.audio_url" style="height: 35px; width: 110px" controls ></audio>
                    </el-col>
                </el-row>
            </el-form-item>

            <el-form-item align="right">
                <el-button class="el-button--small" @click="$emit('closeAdd')">Back</el-button>
                <el-button class="el-button--small el-button--primary" @click="submit('formData')">Save</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    name: "ICraftiesCreate",
    props: {
        closeAdd: Function,
    },
    data() {
        return {
            types: [
                { id: 1, label: "ICraftie" },
                { id: 2, label: "Token" },
                { id: 3, label: "Stickers" }
            ],
            record_times: [
                { value: 900, label: "15 min" },
                { value: 1800, label: "30 min" },
                { value: 3600, label: "60 min" },
                { value: 7200, label: "120 min" },
            ],
            rules: {
                prefix_no: [
                    {
                        required: true,
                        message: "Please enter icraftie prefix!",
                        trigger: "blur",
                    },
                    { max: 2, min: 2, message: "The length of Craftie prefix must be 2!" },
                    {
                        validator: (rule, value, callback) => {
                            if (value.match(/^[A-Za-z]*$/) == null) {
                                callback(new Error("Craftie prefix should be pure letter!"));
                            }
                            callback();
                        },
                        trigger: "blur",
                    },
                ],
                icrafite_type: [{ required: true }],
                icraftie_name: [
                    {
                        required: true,
                        message: "Please enter ICraftie Name!",
                        trigger: "blur",
                    },
                    { max: 32, message: "ICraftie Name can be up to 32 bits!" },
                ],
                describe: [{ required: false }],
                record_time: [{ required: true }],
            },
            formData: {
                img: "https://d25tnx7yp1ims3.cloudfront.net/logo/gld@3x.png",
                icraftie_name: "",
                audio_url: "",
                prefix_no: "",
                describe: "",
                icrafite_type: "",
                record_time: 7200,
            },
        };
    },
    methods: {
        handleAvatarSuccess(res, file) {
            if (res.errcode == 0) {
                this.$message.success("upload successfully!");
                this.formData.img = res.data;
            } else {
                this.$message.success("upload failed!");
            }
        },
        handleAudioSuccess(res, file) {
            if (res.errcode == 0) {
                this.$message.success("upload successfully!");
                this.formData.audio_url = res.data;
            } else {
                this.$message.success("upload failed!");
            }
        },
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid){
                    this.$message.warning("Please check the input data!");
                    return
                }
                this.formData.prefix_no = this.formData.prefix_no.toUpperCase()

                let loading = this.$util.loading();
                if (this.formData.icrafite_type == null || this.formData.record_time == 0) {
                    this.$message.warning("Please check the input data!");
                    return
                }

                this.$api.rootV1.post(
                    "/web/craftie/add/icraftie",
                    this.formData,
                    (res) => {
                        this.$alert("added successfully!", "info", {
                            confirmButtonText: "confirm",
                            type: "success",
                            callback: (action) => {
                                loading.close();
                                this.$emit("closeAdd");
                            },
                        });
                    },
                    (res) => {
                        this.$alert(`Add failed! ${res.errmsg}`, "info", {
                            confirmButtonText: "confirm",
                            type: "error",
                            callback: (action) => {
                                loading.close();
                            },
                        });
                    }
                );
                
            });
        },
    },
};
</script>

<style scoped>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }

    .avatar-uploader-icon {
        font-size: 60px;
        color: #8c939d;
        width: 60px;
        height: 60px;
        line-height: 70px;
        text-align: left;
    }

    .avatar {
        width: 60px;
        height: 60px;
    }
</style>



// WEBPACK FOOTER //
// src/components/main/crafties/ICraftiesCreate.vue